import { Request } from '../../Servidor/Request';

export class BuildingPermitRequest {
    private sgepalvaraconstrucao: number;
    private nome: string;

	constructor(sgepalvaraconstrucao: number, nome: string) {
		this.sgepalvaraconstrucao = sgepalvaraconstrucao;
		this.nome = nome;
	}


    /**
     * Getter sgepalvaraconstrucao
     * @return {number}
     */
	public getSgepalvaraconstrucao(): number {
		return this.sgepalvaraconstrucao;
	}
    

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class BuildingPermitStructRequest {
    private sgepalvaraconstrucao: number;

	constructor(sgepalvaraconstrucao: number) {
        this.sgepalvaraconstrucao = sgepalvaraconstrucao;
	}


    /**
     * Getter sgepalvaraconstrucao
     * @return {number}
     */
	public getSgepalvaraconstrucao(): number {
		return this.sgepalvaraconstrucao;
	}
    

}

export class BuildingPermitInteractor {
    public fetchSave(request: BuildingPermitRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/alvara-construcao/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Status == "Sucesso")
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: BuildingPermitStructRequest): PromiseLike<BuildingPermitRequest> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/alvara-construcao/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}